export default class DonutChart
{
    constructor() {
        this.settings = {
            colors: [
                '#001f3f',
                '#0074d9',
            ]
        };
    }

    setData($element) {
        this.$element = $element;
    }

    getChart() {
        return this.$element.each((key, item)=> {
            let $item = $(item);
            let ctx = item.getContext('2d');
            let segments = [];
            let labels = [];
            let colors = [];

            $item.children().map((foo, value) => {
                let $child = $(value);
                let v = $child.data('value');
                let c = $child.data('color');
                let f = parseFloat(v);

                if (!isNaN(f)) {
                    segments.push(f);
                    labels.push($child.text());
                    colors.push(c);
                } else {
                }
            });

            let canvasWidth = $item.width();
            let canvasHeight = $item.height();
            let xCenter = Math.floor(canvasWidth / 2);
            let yCenter = Math.floor(canvasHeight / 2);
            let radius = Math.ceil(0.8 * Math.min(xCenter, yCenter));
            let innerRadius = Math.ceil(radius / 1.7);

            ctx.clearRect(0, 0, canvasWidth, canvasHeight);
            ctx.restore();
            ctx.save();

            function addText(text, x, y) {
                ctx.lineWidth = 1;
                ctx.fillStyle = "#000";
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.textTransform = 'uppercase';
                ctx.fillText(chartTitle, xCenter, yCenter);
            }

            let i,
                total = 0;

            for (i = 0; i < segments.length; i++) {
                total = total + parseFloat(segments[i]);
            }

            let percentByDegree = 360 / total,
                degToRad = Math.PI / 180,
                currentAngle = 0,
                startAngle = 0,
                endAngle,
                innerStart,
                innerEnd;

            ctx.translate(xCenter, yCenter);
            //Turn the chart around so the segments start from 12 o'clock
            ctx.rotate(270 * degToRad);

            for (i = 0; i < segments.length; i++) {
                startAngle = currentAngle * degToRad;
                endAngle = (currentAngle + (segments[i] * percentByDegree)) * degToRad;

                //Draw the segments
                ctx.fillStyle = colors[i];
                ctx.strokeStyle ="#FFFFFF";
                ctx.lineWidth = 3;

                ctx.beginPath();
                ctx.arc(0, 0, radius, startAngle, endAngle, false);
                ctx.arc(0, 0, innerRadius, endAngle, startAngle, true);
                ctx.closePath();

                ctx.stroke();
                ctx.fill();

                currentAngle = currentAngle + (segments[i] * percentByDegree);
            }
        });
    }
}
